var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoAdvantage6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 43.5377H45V18.4121C45 17.0798 43.8833 16 42.5055 16H23.4945C22.1167 16 21 17.0798 21 18.4121V43.5377Z",
    fill: "#FFBDCD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 45.8076V49.5875C21 50.9199 22.1167 51.9996 23.4945 51.9996H42.5055C43.8833 51.9996 45 50.9199 45 49.5875V45.8076H21ZM34.3044 49.711H31.6955C31.0469 49.711 30.5216 49.203 30.5216 48.5759C30.5216 47.9487 31.0469 47.4408 31.6955 47.4408H34.3044C34.953 47.4408 35.4783 47.9487 35.4783 48.5759C35.4783 49.203 34.953 49.711 34.3044 49.711Z",
    fill: "#FFBDCD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAdvantage6);
export default __webpack_public_path__ + "static/media/ico_advantage6.429bbc52dbe4b3c95544b8e09e12f6b1.svg";
export { ForwardRef as ReactComponent };